<script setup>
defineProps({
  label: String
});
</script>

<template>
  <div class="mb-2 text-lg font-bold md:text-xl" v-text="label" />
</template>
